import { Category } from "../../order/models/category";

export class ProductCategory {
  isLevelUp: boolean

  constructor(
    private _category: Category
  ) {
  }

  get id(): number {
    return this._category?.id;
  }

  get name(): string {
    return this._category?.name;
  }

  get iconUrl(): string {
    return this._category?.iconUrl;
  }

  get category(): Category {
    return this._category;
  }

  static createLevelUp(id: number, name: string): ProductCategory {
    const result = new ProductCategory(new Category(id, name));
    result.isLevelUp = true;
    return result;
  }

}
